<ins-form-field
	type="outlined"
	class="label-inline form-field--frame"
	[label]="chip().label + ':'"
>
	<ins-select
		#insSelectElement
		display-text="displayLabel"
		[converter]='converter'
		[ngModel]="selectValue()"
		(ngModelChange)="onValueChange($event)"
	>
		@if (isChosenValue()) {
			<span slot="content">
				{{getChosenValue()}}
			</span>
		} @else if (selectValue() === null) {
			<span slot="content"></span>
		}
		@for (item of collection(); track item.value) {
			<ins-option
				class="option-size--small"
				[value]="item"
				(click)="onOptionClick(item)">
				<skl-icon name="check" class="select-item__checkmark" [class.display--vanish]="!isSelected(item)"></skl-icon>
				<span>{{ item.label }}</span>
				@if (isChosenItem(item) && isChosenValue()) {
					<span>: {{ getChosenValue() }}</span>
				}
			</ins-option>
		}
		<ins-option slot="footer" class="option-size--small select-item select-list__footer">
			{{ 'ui.filter-chips.restore-default' | translate }}
		</ins-option>
	</ins-select>
</ins-form-field>
